import { render } from "./TermsOfUse.vue?vue&type=template&id=350633d8&scoped=true&ts=true"
import script from "./TermsOfUse.vue?vue&type=script&lang=ts"
export * from "./TermsOfUse.vue?vue&type=script&lang=ts"

import "./TermsOfUse.vue?vue&type=style&index=0&id=350633d8&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/jobs/RECA/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-350633d8"]])

export default __exports__